var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21.547 21.547"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2981",
    d: "M15.439 0a6.061 6.061 0 00-4.318 1.79L9.085 3.826a.815.815 0 001.152 1.152l2.036-2.036a4.478 4.478 0 116.332 6.333l-2.041 2.036a.815.815 0 101.152 1.152l2.036-2.036A6.108 6.108 0 0015.439 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2982",
    d: "M11.311 16.564L9.275 18.6a4.478 4.478 0 11-6.332-6.333l2.036-2.036a.815.815 0 00-1.152-1.152l-2.035 2.035a6.107 6.107 0 108.635 8.637l2.036-2.036a.815.815 0 10-1.152-1.152z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2983",
    d: "M13.723 7.825a2.442 2.442 0 00-3.455 0l-2.443 2.443a2.443 2.443 0 103.455 3.455l2.443-2.443a2.442 2.442 0 000-3.455zm-1.152 2.3l-2.444 2.443a.832.832 0 01-1.151 0 .813.813 0 010-1.151l2.444-2.443a.813.813 0 011.151 0 .813.813 0 010 1.151z"
  }))));
}

export default SvgLink;